<template>
  <div>
    <button class="ph-dock__trigger" :class="{ 'ph-dock__trigger--active': activeFilterCount > 0 }" :title="$t('photos.filter.title')" @click.stop="open = !open">
      <md-icon>filter_alt</md-icon>
      <span v-if="activeFilterCount" class="ph-dock__badge">{{ activeFilterCount }}</span>
    </button>

    <div v-if="open" class="ph-filter__overlay" @click="open = false"></div>
    <aside class="ph-filter__panel" :class="{ 'is-open': open }">
      <div class="ph-filter__head">
        <h4>{{ $t("photos.filter.title") }}</h4>
        <md-button class="md-simple md-just-icon md-round" @click="open = false"><md-icon>close</md-icon></md-button>
      </div>

      <div class="ph-filter__body">
        <!-- Art: Produktbilder / Reklamationsbilder / Retourenbilder (weitere folgen) -->
        <div class="ph-filter__section">
          <div class="ph-filter__label">{{ $t("photos.filter.source") }}</div>
          <md-checkbox v-for="s in sourceOptions" :key="s.id" v-model="draft.sources" :value="s.id" class="ph-filter__check">{{ s.name }}</md-checkbox>
        </div>
        <!-- Innerhalb der Retouren: die Fotoart -->
        <div class="ph-filter__section">
          <div class="ph-filter__label">
            <span>{{ $t("photos.filter.photoType") }}</span>
            <button v-if="draft.photoTypeId !== null" class="ph-filter__clear" :title="$t('photos.filter.clearOne')" @click="draft.photoTypeId = null">
              <md-icon>close</md-icon>
            </button>
          </div>
          <v-select
            class="custom-select"
            :options="photoTypes"
            :reduce="(o) => o.id"
            :getOptionLabel="(o) => o.name || o.code"
            :value="draft.photoTypeId"
            :append-to-body="true"
            @input="draft.photoTypeId = $event"
          />
          <p class="ph-filter__hint">{{ $t("photos.filter.photoTypeHint") }}</p>
        </div>
      </div>

      <div class="ph-filter__foot">
        <md-button class="md-secondary md-sm" @click="clearAll">{{ $t("photos.filter.clearAll") }}</md-button>
        <md-button class="md-success md-sm" @click="apply">{{ $t("photos.filter.apply") }}</md-button>
      </div>
    </aside>
  </div>
</template>

<script>
// Filter-Drawer des Foto Managers nach dem Muster der Retouren (ReturnsDrawerFilter.vue)
const EMPTY = { sources: [], photoTypeId: null };

export default {
  name: "PhotosDrawerFilter",
  props: {
    photoTypes: { type: Array, default: () => [] },
  },
  data() {
    return { open: false, draft: { ...EMPTY, sources: [] }, applied: { ...EMPTY, sources: [] } };
  },
  computed: {
    sourceOptions() {
      return ["product", "order", "return"].map((id) => ({ id, name: this.$t("photos.sources." + id) }));
    },
    activeFilterCount() {
      let n = 0;
      if (this.applied.sources.length) n += 1;
      if (this.applied.photoTypeId !== null) n += 1;
      return n;
    },
  },
  watch: {
    open(neu) {
      if (neu) {
        this.draft = { sources: [...this.applied.sources], photoTypeId: this.applied.photoTypeId };
        this.$emit("opened");
      } else {
        this.$emit("closed");
      }
    },
  },
  methods: {
    apply() {
      this.applied = { sources: [...this.draft.sources], photoTypeId: this.draft.photoTypeId };
      this.open = false;
      this.$emit("apply-filters", { sources: [...this.applied.sources], photoTypeId: this.applied.photoTypeId });
    },
    clearAll() {
      this.draft = { sources: [], photoTypeId: null };
      this.apply();
    },
  },
};
</script>

<style lang="scss" scoped>
.ph-filter__overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.25);
  z-index: 1049;
}
.ph-filter__panel {
  position: fixed;
  top: 0;
  right: -420px;
  width: 400px;
  max-width: 92vw;
  height: 100vh;
  background: #fff;
  z-index: 1050;
  box-shadow: -2px 0 12px rgba(0, 0, 0, 0.2);
  transition: right 0.25s ease;
  display: flex;
  flex-direction: column;

  &.is-open {
    right: 0;
  }
}
.ph-filter__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;

  h4 {
    margin: 0;
    font-size: 16px;
  }
}
.ph-filter__body {
  flex: 1;
  overflow-y: auto;
  padding: 12px 16px;
}
.ph-filter__section {
  margin-bottom: 16px;
}
.ph-filter__label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
}
.ph-filter__check {
  display: flex;
  margin: 6px 0;
}
.ph-filter__hint {
  font-size: 11px;
  color: #999;
  margin: 4px 0 0;
}
.ph-filter__clear {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;

  .md-icon {
    font-size: 16px !important;
    color: #b71c1c;
  }
}
.ph-filter__foot {
  display: flex;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 1px solid #eee;
}
</style>
